import React from 'react';

const NonAuthLayout = ({ children }) => {
  return <>{children}</>;
};

export default NonAuthLayout;
